var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review-log-detail" },
    [
      _vm.structured
        ? [
            _c("dl", [
              _c("dt", [_vm._v("Invoice")]),
              _c("dd", [_vm._v(_vm._s(_vm.data.invoiceId))]),
              _c("dt", [_vm._v("Transaction")]),
              _c("dd", [_vm._v(_vm._s(_vm.data.transNo || "—"))]),
              _c("dt", [_vm._v(_vm._s(_vm.t("client")))]),
              _c("dd", [_vm._v(_vm._s(_vm.data.clientCode))]),
              _c("dt", [_vm._v(_vm._s(_vm.t("week")))]),
              _c("dd", [_vm._v(_vm._s(_vm.data.billingWeekStart))]),
              _c("dt", [_vm._v(_vm._s(_vm.t("source")))]),
              _c("dd", [_vm._v(_vm._s(_vm.data.source))]),
              _c("dt", [_vm._v(_vm._s(_vm.t("reason")))]),
              _c("dd", { staticClass: "reason" }, [
                _vm._v(_vm._s(_vm.data.reason || "—")),
              ]),
            ]),
            _c("div", { staticClass: "snapshots" }, [
              _c("section", [
                _c("strong", [_vm._v(_vm._s(_vm.t("before")))]),
                _c("pre", [_vm._v(_vm._s(_vm.json(_vm.data.before)))]),
              ]),
              _c("section", [
                _c("strong", [_vm._v(_vm._s(_vm.t("after")))]),
                _c("pre", [_vm._v(_vm._s(_vm.json(_vm.data.after)))]),
              ]),
            ]),
          ]
        : _c("pre", [_vm._v(_vm._s(_vm.json(_vm.data)))]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }